






























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
import TimeTab from "./time-tab.vue";
import Shetubaogao from "../../../../../tongue/views/tongue-preview/shetubaogao.vue";
import Dingxing from "../../../../../tongue/views/tongue-preview/dingxing.vue";
import Yanse from "../../../../../tongue/views/tongue-preview/yanse.vue";
import Jihe from "../../../../../tongue/views/tongue-preview/jihe.vue";
import Wenli from "../../../../../tongue/views/tongue-preview/wenli.vue";
import Fenzu from "../../../../../tongue/views/tongue-preview/fenzu.vue";
@Component({
  components: {
    PicPreview,
    TimeTab,
    Shetubaogao,
    Dingxing,
    Yanse,
    Jihe,
    Wenli,
    Fenzu,
  },
})
export default class IdrSheKeyan extends Vue {
  @Prop()
  private message: any;
  private current: any = {};
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private tongueIndex: any = 0;
  private cState: any = "舌图报告";
  private changeCurrentItem(item, index) {
    this.$set(this, "current", item);
    this.tongueIndex = index;
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  /**
   * @description 改变显示部分
   */
  private changeState(state) {
    this.cState = state;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.message && this.message.length > 0) {
      this.current = this.message[0];
    }
  }
}
